export function characterCountRule(
  counter: number,
  message = `Dieses Feld darf nicht länger als ${counter} Zeichen sein.`
): (value: any) => boolean | string {
  return value => value.length <= counter || message;
}
